import type { NestedFilter } from '@@partner:graphql/types'
import type { FilterConfig } from '@components/common/filter/FilterConfig'

import React, { useCallback } from 'react'
import FilterPanel from '@components/common/filter/FilterPanel'
import { createFilter } from '@components/common/filter/FilterConfig'
import { preparePromocodeFilter, PromocodeFiltersType } from '@@partner:helpers/promocode'

export interface PromocodesFilterProps {
  onFilterChanged: (filters: NestedFilter) => void
}

const defaultFilter: PromocodeFiltersType = {
  id: undefined,
  code: undefined,
  type: undefined,
  delivery_discount: undefined
}

const filterConfig: FilterConfig[] = [
  createFilter.text('id', 'ID'),
  createFilter.text('code', 'Код промокода'),
  createFilter.text('delivery_discount', 'Скидка на доставку')
]

export default function PromocodesFilter ({
  onFilterChanged
}: PromocodesFilterProps) {
  const handleSearch = useCallback((state: PromocodeFiltersType) => {
    onFilterChanged(preparePromocodeFilter(state))
  }, [ onFilterChanged ])

  return (
    <FilterPanel<PromocodeFiltersType>
      filters={filterConfig}
      defaultState={defaultFilter}
      onSearch={handleSearch}
    />
  )
}
